export default "__VITE_ASSET__CUpPeeHf__"